import { Box, useDisclosure } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import DealerCardResults from './result-lists/DealerCardResults';
import LicenseNumberResult from './result-lists/LicenseNumberResult';
import TextResults from './result-lists/TextResults';
import { CognitoInterface } from '@/queue/Queue';
import ExploreLandingPage from './result-lists/ExploreLandingPage';
import { useDispatch } from 'react-redux';
import {
  setLicenseByZipDistance,
  setLicenseByZipQueryParams,
  setQuery,
  setSearchRecognizer,
  setShowDropdownSlice
} from './ducks/slice';
import {
  getIsSearchStarted,
  getIsSearchingDealer,
  getLicenseByZipDistance,
  getLicenseByZipQueryParams,
  getQuery,
  getSearchCount,
  getSearchRecognizer
} from './ducks/selectors';
import {
  ZipCodeRecognizer,
  BusinessNameRecognizer,
  FFLRecognizer,
  Recognizer,
  FFLSearchComponent
} from '@masterffl/ffl-search-component';
import { LicenseByZipParamsInterface } from '@/model/explore';
import { useSearchParams } from 'react-router-dom';
import { ShowTransferModel } from '@/queue/elements/QueueGrid';
import { callToAssignTransferDealer } from '@/queue/ducks/slice';
import { getEightDigitLicenseKey } from './ffl-detail/utils.mjs';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import { Toastertype } from '@/queue/types';
import { DEALER_ALREADY_ASSIGNED_ERROR } from '@/utils/constants';

export default function Explore({
  cognitoGroup,
  isSuperAdmin,
  isAssignDealerModal,
  assignNewDealerInitialZipCode,
  transferId,
  onCloseAssignDealerModal,
  assignedDealerLicenseKey
}: CognitoInterface) {
  const query = getQuery();
  const searchRecognizer = getSearchRecognizer();
  const [srchRcgnzer, setSrchRcgnzer] = useState(searchRecognizer);
  const dispatch = useDispatch();
  const getParams = getLicenseByZipQueryParams();
  const getDistance = getLicenseByZipDistance();
  const searchCountChange = getSearchCount();
  const searchStateChange = getIsSearchStarted();
  const [selectedView, setSelectedView] = useState('list');
  const [searchCount, setSearchCount] = useState(searchCountChange);
  const [isSearchStarted, setIsSearchStarted] = useState(searchStateChange);
  const isSearchingDealer = getIsSearchingDealer();
  const [isSearchingDealerData, setIsSearchingDealerData] = useState<boolean>(isSearchingDealer);
  const [queryParams, setQueryParams] = useSearchParams();
  const {
    isOpen: isTransferModalOpen,
    onClose: onCloseTransferModal,
    onOpen: onOpenTransferModal
  } = useDisclosure();
  const showTransferId = queryParams.get('transfer_id');
  console.log({query, getParams, queryParams, searchRecognizer})
  useEffect(() => {
    if(assignNewDealerInitialZipCode) {
      dispatch(setQuery([assignNewDealerInitialZipCode]));
      const zipCodeRecognizer = new ZipCodeRecognizer();
      if(zipCodeRecognizer.matches(assignNewDealerInitialZipCode) && zipCodeRecognizer.match) {
        dispatch(setQuery([assignNewDealerInitialZipCode]));
        handleSearchSubmit(assignNewDealerInitialZipCode, zipCodeRecognizer);
      }
    }
    if(!isAssignDealerModal)
      document.body.setAttribute('class', 'explore-page');
    return () => {
      document.body.removeAttribute('class');
    };
  }, []);
  useEffect(() => {
    setIsSearchStarted(searchStateChange)
  }, [searchStateChange])
  
  useEffect(() => {
    if (searchCountChange) {
      searchCountChange == -1 ? setSearchCount(0) : setSearchCount(searchCountChange);
    }
  }, [searchCountChange]);

  useEffect(() => {
    setIsSearchingDealerData(isSearchingDealer);
  }, [isSearchingDealer]);

  useEffect(() => {
    setSrchRcgnzer(searchRecognizer);
  }, [searchRecognizer]);

  useEffect(() => {
    if (window) {
      const transferId = queryParams.get('transfer_id');
      if (transferId) onOpenTransferModal();
    }
  }, [queryParams]);

  function handleSearchSubmit(searchString: string, recognizer: Recognizer) {
    if(isAssignDealerModal && recognizer instanceof FFLRecognizer) return;
    dispatch(setQuery(recognizer.match));
    dispatch(setSearchRecognizer(recognizer));
  }

  const onDealerAssigned = (dealerId: any) => {
    const selectedDealerLicenseKey = getEightDigitLicenseKey(dealerId);
    assignedDealerLicenseKey = assignedDealerLicenseKey ? getEightDigitLicenseKey(assignedDealerLicenseKey) : '';
    if(assignedDealerLicenseKey === selectedDealerLicenseKey){
      OutlineToasterNotification(
        Toastertype.error,
        DEALER_ALREADY_ASSIGNED_ERROR,
        () => {},
        ``,
        true
      );
    } else {
      dispatch(callToAssignTransferDealer({ transferId: transferId as string, licenseKey: selectedDealerLicenseKey}));
    }
  }

  /**
   * Render a search results list depending on the query type
   */
  function renderSwitch() {
    if(!isAssignDealerModal)
      document.body.setAttribute('class', 'explore-page');
    if (query) {
      if (srchRcgnzer instanceof ZipCodeRecognizer) {
        return (
          <DealerCardResults
            query={query[1]}
            cognitoGroup={cognitoGroup}
            isSuperAdmin={isSuperAdmin}
            searchRecognizer={srchRcgnzer}
            selectedView={selectedView}
            isFFLSelect={isAssignDealerModal}
            onDealerAssigned={onDealerAssigned}
          />
        );
      } else if (srchRcgnzer instanceof FFLRecognizer) {
        document.body.removeAttribute('class');
        return (
          <LicenseNumberResult
            first1={query[1]}
            second2={query[2]}
            last5={query[query.length - 1]}
            cognitoGroup={cognitoGroup}
            isSuperAdmin={isSuperAdmin}
          />
        );
      } else if (srchRcgnzer instanceof BusinessNameRecognizer) {
        return (
          <DealerCardResults
            query={query[0]}
            cognitoGroup={cognitoGroup}
            isSuperAdmin={isSuperAdmin}
            searchRecognizer={srchRcgnzer}
            selectedView={selectedView}
            isFFLSelect={isAssignDealerModal}
            onDealerAssigned={onDealerAssigned}
          />
        );
      } else {
        return <TextResults query={query[0]} />;
      }
    }
  }

  /**
   * Render a variable form layout based on whether a query is submitted or not
   */
  const onChangeDistance = (distance: number) => {
    dispatch(setLicenseByZipDistance(String(distance)));
  };
  const onSortOptionsChange = (
    licenseByZipQueryParams: LicenseByZipParamsInterface
  ) => {
    dispatch(setLicenseByZipQueryParams(licenseByZipQueryParams));
  };
  const onChangeMapView = (type: string) => {
      setSelectedView(type);
  };
  const onCloseTransferModalHandler = () => {
    onCloseTransferModal();
    queryParams.delete('transfer_id');
    setQueryParams(queryParams);
  };

  useEffect(() => {
    const notFound = document.getElementById('not-found-section');
    const height = `calc(100vh - 369px)`
    if (notFound) {
      notFound.style.minHeight = `${height} !important`
    }
  }, [])
  function renderForm() {
    if (query) {
      return (
        <>
          <FFLSearchComponent
            searchCount={searchCount}
            isSearchStarted={isSearchStarted}
            isSearchingDealer={isSearchingDealerData}
            onChangeMapView={onChangeMapView}
            inputQuery={query}
            inputDistance={getDistance}
            searchRecognizer={srchRcgnzer}
            searchParams={getParams}
            handleSearchSubmit={handleSearchSubmit}
            onChangeDistance={onChangeDistance}
            onSortOptionsChange={onSortOptionsChange}
            filterConfiguration={{}}
            searchPlaceholder={isAssignDealerModal ? "Search a Zip code, Receiving FFL here....." : null}
            isMapBUttonDisable={Boolean(isAssignDealerModal)}
          />
          {renderSwitch()}
        </>
      );
    } else {
      return (
        <>
          <FFLSearchComponent
            searchCount={searchCount}
            isSearchStarted={isSearchStarted}
            onChangeMapView={onChangeMapView}
            inputQuery={query}
            inputDistance={getDistance}
            searchRecognizer={srchRcgnzer}
            searchParams={getParams}
            handleSearchSubmit={handleSearchSubmit}
            onChangeDistance={onChangeDistance}
            onSortOptionsChange={onSortOptionsChange}
            filterConfiguration={{}}
            searchPlaceholder={isAssignDealerModal ? "Search a Zip code, Receiving FFL here....." : null}
            isMapBUttonDisable={Boolean(isAssignDealerModal)}
          />
          <ExploreLandingPage hideText={true} />
        </>
      );
    }
  }

  return (
    <Box className={'Explore explore-container'}>
      {isTransferModalOpen && (
        <ShowTransferModel
          isOpen={isTransferModalOpen}
          onClose={onCloseTransferModalHandler}
          transfer={{ id: showTransferId as string }}
          reFetchData={() => {}}
          isSuperAdmin={isSuperAdmin}
          isStoreAdmin={false}
          cognitoGroup={false}
        />
      )}
      {renderForm()}
    </Box>
  );
}
